import type { ResolveEntityBreadcrumbLabelParams } from '../types';

const resolveEntityBreadcrumbLabel = ({
    entityId,
    entityName,
    isLoading,
    entityKindLabel,
}: ResolveEntityBreadcrumbLabelParams): string => {
    if (entityName) {
        return entityName;
    }

    if (isLoading) {
        return '...';
    }

    const shortId = entityId.slice(0, 8);
    return shortId.length > 0 ? `${entityKindLabel} ${shortId}...` : entityKindLabel;
};

export default resolveEntityBreadcrumbLabel;
